import { isMember } from "../utils"

export const Navbar = () => <div class="venue-navbar-wrapper">
	<div class="topnavtk2 left-nav" id="myTopnavtk2">
		<a href="#" id="LeaveEvent" class="activetk2">Leave Event</a>
		{
			isMember && <>
				<div class="dropdowntk2">
					<button class="dropbtntk2">Schedule
						<i class="fa fa-caret-down" />
					</button>
					<div class="dropdown-contenttk2">
						<a href="https://isfcongress.tkeventsregistration.com/digital2021/personalschedule" title="Personal Agenda">Personal Agenda</a>
						<a href="https://isfcongress.tkeventsregistration.com/digital2021/fullschedule" title="Full Schedule">Full Schedule</a>
					</div>
				</div>
			</>
		}
		<a href="/atrium" title="Atrium">Atrium</a>
		<div class="dropdowntk2">
			<button class="dropbtntk2">Room Navigation
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="/auditorium" title="Auditorium" onClick={() => window.openChat("keynotes")}>Auditorium</a>

				<a href="/breakouts" title="Breakout Foyer">Breakout Foyer</a>
				{
					isMember && <>
						<a href="/breakout-one" title="Breakout 1" onClick={() => window.openChat("breakout-1")}>Breakout 1</a>
						<a href="/breakout-two" title="Breakout 2" onClick={() => window.openChat("breakout-2")}>Breakout 2</a>
						<a href="/breakout-three" title="Breakout 3" onClick={() => window.openChat("breakout-3")}>Breakout 3</a>
					</>
				}
				<a href="/breakout-four" title="Breakout 4" onClick={() => window.openChat("breakout-4")}>Breakout 4</a>
				{
					isMember && <>
						<a href="/engagement-sessions" title="Engagement Sessions">Engagement Sessions</a>
					</>
				}
				<a href="/exhibition-hall" title="Exhibition Hall">Exhibition Hall</a>
				{
					isMember && <>
						<a href="/lounge" title="Interactive Lounge">Interactive Lounge</a>
						<a href="/exploration-zone" title="Exploration Zone" onClick={() => window.openChat("exploration-zone")}>Exploration Zone</a>
						<a href="/roundtables" title="Roundtable Sessions">Roundtable Sessions</a>
						<a href="/speaker-gallery" title="Speaker Gallery">Speaker Gallery</a>
					</>
				}
				<a href="/sponsor-theatre" title="Sponsor Theatre">Sponsor Theatre</a>
			</div>
		</div>
		{
			isMember
			? <>
				<div class="dropdowntk2">
					<button class="dropbtntk2">Directories
						<i class="fa fa-caret-down" />
					</button>
					<div class="dropdown-contenttk2">
					<a href="https://isfcongress.tkeventsregistration.com/digital2021/attendeedirectory" title="Attendee Directory">Attendee Directory</a>
					<a href="https://isfcongress.tkeventsregistration.com/digital2021/speakerdirectory" title="Speaker Directory">Speaker Directory</a>
					<a href="https://isfcongress.tkeventsregistration.com/digital2021/sponsordirectory" title="Sponsor Directory">Sponsor Directory</a>
					</div>
				</div>
				{ new Date() > new Date("2021-10-26 09:00+01:00") && <a href="https://isfcongress.tkeventsregistration.com/digital2021/ondemand" target="_blank" title="Atrium">On-Demand</a>}
			</>
			: <a href="https://isfcongress.tkeventsregistration.com/digital2021/sponsordirectorynm" title="Sponsor Directory">Sponsor Directory</a>
		}
	</div>
	{
		isMember && window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes" && <>
			<div class="gamification-buttons-wrapper topnavtk2">
				<a class="gamification-button" id="how-to-earn" style="cursor: pointer" title="How to Earn Points">How to Earn Points</a>
				<a style="cursor: pointer" onclick={() => { document.getElementById("Leaderboard").click() }} title="Leaderboard">Leaderboard</a>
			</div>
		</>
	}
</div>
